<section class="checkbox-grid__row">
  <div class="checkbox-row__details">
    <p class="t-data t-bold">{{ row.primary_text }}</p>
    <p class="t-caption t-alt">{{ row.secondary_text }}</p>
  </div>
  <div class="checkbox-grid__cell-wrapper">
    @for (item of ownRow.items; track item) {
      <checkbox-cell
        [isReadOnly]="isReadOnly"
        (itemChecked)="handleItemChecked($event)"
        [row]="ownRow"
        [item]="item"
      >
      </checkbox-cell>
    }
  </div>
</section>
